import { CONTAINER_NAME } from "../_utils/constant";
import { isDingdingMiniapp } from "../_utils/miniappEnvApp";
import { normalize } from "../common";
var upload = normalize.upload(function (options) {
  var url = options.url,
      filePath = options.filePath,
      fileName = options.fileName,
      _options$fileType = options.fileType,
      fileType = _options$fileType === void 0 ? 'image' : _options$fileType,
      hideLoading = options.hideLoading,
      header = options.header,
      formData = options.formData,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;
  var uploadFile = isDingdingMiniapp ? dd.uploadFile : my.uploadFile;
  var task = uploadFile({
    url: url,
    filePath: filePath,
    fileName: fileName,
    fileType: fileType,
    hideLoading: hideLoading,
    header: header,
    formData: formData,
    success: function success(res) {
      _success && _success(res);
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });

  if (task && task.onProgressUpdate) {
    // 支付宝 10.1.35 及以上版本支持
    var progressCallback = [];
    task.onProgressUpdate(function (_ref) {
      var progress = _ref.progress,
          totalBytesWritten = _ref.totalBytesWritten,
          totalBytesExpectedToWrite = _ref.totalBytesExpectedToWrite;
      var res = {
        progress: progress,
        totalBytesSent: totalBytesWritten,
        totalBytesExpectedToSend: totalBytesExpectedToWrite
      };

      if (progressCallback.length > 0) {
        progressCallback.forEach(function (x) {
          return x(res);
        });
      }
    });
    return {
      abort: function abort() {
        task.abort();
      },
      onProgressUpdate: function onProgressUpdate(cb) {
        progressCallback.push(cb);
      },
      offProgressUpdate: function offProgressUpdate(cb) {
        if (progressCallback.indexOf(cb) !== -1) {
          progressCallback.splice(progressCallback.indexOf(cb), 1);
        }
      }
    };
  }
}, CONTAINER_NAME.ALIPAY);
export default upload;